// 다국어 번역 데이터
export const getTranslations = (config) => ({
        ko: {
                // 헤더
                weddingDay: 'WEDDING DAY',

                // 날짜/장소
                date: config.date.ko,
                place: config.place.ko,
                dateShort: config.dateShort.ko,
                days: '일',
                hours: '시간',
                minutes: '분',
                seconds: '초',

                // 인사말
                greeting: `각자의 꿈을 향해
걸어오던 두 사람이
이제는 함께 같은 꿈을 향해
나아가려 합니다.
그 시작의 자리에
소중한 분들을 초대합니다.`,
                songCredit: `영화 '위대한 쇼맨' OST 'A Million Dreams'`,

                // 부모님
                son: '아들',
                daughter: '딸',

                // 갤러리
                gallery: 'GALLERY',

                // 피로연 안내
                receptionInfo: '피로연 안내',

                // 마음 전하는 곳
                bankAccount: '마음 전하는 곳',
                bankAccountDesc: '축하의 마음을 담아 축의금을 전달해보세요.',
                groomAccount: '신랑측 계좌번호 복사',
                brideAccount: '신부측 계좌번호 복사',

                // 메시지
                message: 'MESSAGE',
                leaveMessage: '축하 메시지 남기기',
                messageTitle: '축하 메시지',
                messageDesc: '축하 메시지를 남겨주세요.',
                name: '이름',
                password: '비밀번호',
                messagePlaceholder: '축하 메시지를 입력하세요.',
                submitMessage: '메시지 남기기',
                deleteMessage: '메시지 삭제',
                deletePasswordDesc: '비밀번호를 입력해주세요.',
                cancel: '취소',
                delete: '삭제',
                deleting: '삭제 중...',
                submitting: '등록 중...',
                noMessages: '아직 등록된 메시지가 없습니다.',
                loadingMessages: '메시지를 불러오는 중...',

                // 오시는 길
                directions: '오시는 길',
                address: config.address.ko,
                publicTransport: '대중 교통',
                publicTransportDesc: `2호선 삼성역 3번 출구에서
도보 8분, 버스(강남01, 강남06, 지선4319)
대치2동 주민센터, 래미안 하이스턴 하차`,
                car: '자가용',
                carDesc: `트라디노이 주차장
대치 2동 주민센터 주차장 이용 가능
※ 주차 공간이 협소하오니, 가급적 대중교통을 이용해 주시면 감사하겠습니다.`,
                naver: '네이버',
                kakao: '카카오',
                google: '구글',

                // 안내사항
                notice: '안내사항',
                notice1: `소중한 분들을 모두 모시고 싶지만
장소가 협소한 관계로 참석 가능 여부를
알려주신 분들에 한해 좌석을
마련해드릴 수 있는점
너그러이 양해 부탁드립니다.`,
                notice2: `공간이 협소하여 화환 진열이 어렵습니다.
꽃바구니로 보내주시는 경우,
소중히 받아 예식장 장식에 활용할 예정입니다.`,
        },
        ja: {
                weddingDay: 'WEDDING DAY',
                date: config.date.ja,
                place: config.place.ja,
                dateShort: config.dateShort.ja,
                days: '日',
                hours: '時間',
                minutes: '分',
                seconds: '秒',
                greeting: `謹啓　陽春の候

皆様にはますますご清祥のこととお喜び申し上げます。

それぞれの夢を目指し歩んできた私ども二人は
このたび結婚式を挙げることとなりました。
これからは一緒に同じ夢を目指し
新たな一歩を踏み出してまいります。

つきましては
日ごろお世話になっております皆様にお集まりいただき
ささやかな披露宴を催したいと存じます。
ご多用中、誠に恐縮ではございますが
ご出席賜りますようご案内申し上げます。

謹白`,
                songCredit: `映画『グレイテスト・ショーマン』OST「A Million Dreams」`,
                son: '息子',
                daughter: '娘',
                gallery: 'GALLERY',
                receptionInfo: '披露宴ご案内',
                bankAccount: 'お祝いのお気持ちについて',
                bankAccountDesc: `ご祝儀につきまして、ご希望の方に向け、
                下記に口座番号を記載させていただきました。`,
                groomAccount: '新郎側口座番号をコピー',
                brideAccount: '新婦側口座番号をコピー',
                message: 'MESSAGE',
                leaveMessage: 'お祝いメッセージを残す',
                messageTitle: 'Message',
                messageDesc: 'お祝いメッセージを残してください。',
                name: 'お名前',
                password: 'パスワード',
                messagePlaceholder: 'メッセージを入力してください。',
                submitMessage: '送信',
                deleteMessage: 'メッセージを削除',
                deletePasswordDesc: 'パスワードを入力してください。',
                cancel: 'キャンセル',
                delete: '削除',
                deleting: '削除中...',
                submitting: '送信中...',
                noMessages: 'まだメッセージがありません。',
                loadingMessages: '読み込み中...',
                directions: 'アクセス',
                address: config.address.ja,
                publicTransport: '交通機関でお越しの方',
                publicTransportDesc: `2号線サムソン駅3番出口から
徒歩約8分、バス カンナム01、カンナム06、4319（2停留所、約6分）
デチ2洞住民センター、レミアンハイストンアパート下車`,
                car: '車でお越しの方',
                carDesc: `トラディノイ駐車場
デチ2洞住民センター駐車場利用可能
※駐車スペースが限られているため、恐縮ではございますが、公共交通機関をご利用ください。`,
                naver: 'Naver',
                kakao: 'Kakao',
                google: 'Google',
                notice: 'ご案内',
                notice1: `大切な皆様をお招きしたいのですが
会場が狭いため、御座席に限りがございます。
お手数ではございますが、ご都合の程を
ご一報賜りますようお願い申し上げます。`,
                notice2: `挙式にもご列席賜りたく存じますので誠に恐れ入りますが、
                当日は12時15分までにお越しくださいますよう
                よろしくお願い申し上げます。`,
        },
});

// 브라우저 언어 감지
export const detectLanguage = () => {
        if (typeof window === 'undefined') return 'ko';

        // navigator.languages 배열 우선 확인 (여러 언어 설정 지원)
        const languages = navigator.languages || [navigator.language || navigator.userLanguage];

        for (const lang of languages) {
                const langCode = lang.split('-')[0].toLowerCase();

                // 지원하는 언어: ko, ja
                if (langCode === 'ko' || langCode === 'ja') {
                        return langCode;
                }
        }

        // 기본값: 한국어
        return 'ko';
};

